exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-responsive[data-v-495405a2] {\n    overflow: visible;\n}\n", ""]);

// exports
